import React from 'react'
import className from 'classnames/bind'

import style from './MyhouseMainRegisterDeriveGuide.module.scss'

import { MyhouseLabelType } from '@Root/utils/houseLabelUtils'
import { MODAL_TYPE } from '@Root/contants/myhouseModal'
import { LAND_SERVICE_PREFIX_URL } from '@Root/contants/urlConstants'
import useModal from '@Hooks/myhouse/useModal'
import { NCLICK } from '@Root/contants/lcs'
import { handleNclick } from '@Helpers/nclick'
import { MYHOUSE_MAX_COUNT } from '@Root/contants/myhouseRegister'

const cx = className.bind(style)

type props = {
  houses: MyhouseLabelType[]
}

const MyhouseMainRegisterDeriveGuide: React.FC<props> = ({ houses }: props) => {
  const { open } = useModal()

  const handleClick = (e: React.SyntheticEvent) => {
    handleNclick(NCLICK.MY_HOUSE.MAIN_INFO.AUTHENTICATION_GUIDE.RESIDENTIAL_ADD_HOME, e)

    if (houses.length >= MYHOUSE_MAX_COUNT) {
      open(MODAL_TYPE.MYHOUSE_LIMITED)
      e.preventDefault()
    }
  }
  return (
    <>
      <div className={cx('article')}>
        <strong className={cx('title')}>살고 계신 집도 등록해 보세요.</strong>
        <p className={cx('text')}>우리집은 주거용 부동산에 최적화된 서비스입니다. 주택 등록 시 우리집 시세, 단지 공지사항, 입주민 리뷰 등의 서비스를 이용하실 수 있습니다.</p>
        <a href={`${LAND_SERVICE_PREFIX_URL.MYHOUSE_REGISTER}/address`} className={cx('link_add')} onClick={handleClick}>
          주거용 부동산 추가하기
        </a>
      </div>
    </>
  )
}

export default MyhouseMainRegisterDeriveGuide
